import {addremovefilters, clearAllFilters} from "../actions";

export function transformDailyStats(input) {
    let toreturn = {};
    let colors = ["#5E37FF", "#6AD2FF", "#E1E9F8", "#FF6F91", "#FF9A8B"];

    toreturn.response = Object.values(
        input.reduce((acc, {platform, record_count}) => {
            if (!acc[platform]) {
                acc[platform] = {
                    name: platform.toUpperCase(),
                    data: [],
                };
            }
            acc[platform].data.push(Number(record_count));
            return acc;
        }, {})
    ).map((item, index) => ({...item, index}));

    toreturn.labels = input.map(a => a.Date);

    toreturn.response.map((item, index) => {
        item.color = colors[index];
    });


    return toreturn;
}


export function sumFunctionCalls(data) {
    const sumData = data.reduce((acc, obj) => {
        Object.entries(obj).forEach(([key, value]) => {
            acc[key] = (acc[key] || 0) + value;
        });
        return acc;
    }, {});


    return [{
        data: Object.entries(sumData).filter(([key, value]) => key !== "functionIndex").map(([key, value]) => ({
            x: key,
            y: value
        })).sort((a, b) => b.y - a.y)
    }];
}

export function transformArrayToXY(arr) {
    const counts = arr.reduce((acc, item) => {
        acc[item] = (acc[item] || 0) + 1;
        return acc;
    }, {});


    return Object.keys(counts).map(key => ({
        x: key,
        y: counts[key],
    })).sort((a, b) => b.y - a.y);
}

export const getFirstXDataWrapped = (obj, x) => [{data: obj[0].data.slice(0, x)}];


export const applyFilters = (data, filters) => {
    // console.log("filters", filters);

    return data.filter(item =>
        filters.every(filter => {
            if (filter.filtername == "Date") {
                const itemDate = new Date(item["Date"]);
                const startDate = new Date(filter.value[0]);
                const endDate = new Date(filter.value[1]);

                return itemDate >= startDate && itemDate <= endDate;
            } else {
                const itemValue = item[filter.filtername];
                return itemValue && itemValue.toLowerCase().includes(filter.value.toLowerCase());
            }
        })
    );
};



export const clearFilters = (perday = []) => {
    clearAllFilters();

    if(perday.length > 0){
        let daterange = getDateRange(perday);
        addremovefilters({filtername: "Date", value: daterange});
    }

};



export function getDateRange(objectsArray) {
    if (!objectsArray || objectsArray.length === 0) {
        return [];
    }

    // Parse the dates and sort them
    const dates = objectsArray
        .map(obj => new Date(obj.Date)) // Convert string to Date object
        .sort((a, b) => a - b); // Sort in ascending order

    // Return the smallest and largest date as an array
    return [dates[0], dates[dates.length - 1]];
}
